<template>
    <v-row class="pa-6">
        <v-col cols="12" sm="6" md="10">
            <v-data-table 
                :headers="headers" 
                :items="shoppingDetail" 
                class="elevation-0" 
                style="background: #f7f7f7;!important" 
                dense
            >
                <!-- Tabla sin información -->
                <template v-slot:no-data>
                    No existen registros de compras aún
                </template>
                <!-- Acciones por fila -->
                <template v-slot:[`item.actions`]="{ item }">
                    <v-menu bottom left v-if="(permissions('editShoppingOrder') || permissions('deleteShoppingOrder')) && shopping.received!=true">
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                        </template>
                        <v-list style="font-size:13px;">
                            <v-list-item @click="editItem(item.editedItem)"  v-show="permissions('editShoppingOrder')">
                                <v-icon small class="mr-2">
                                    mdi-pencil
                                </v-icon>
                                Editar
                            </v-list-item>
                            <v-list-item @click="deleteItem(item)"  v-show="permissions('deleteShoppingOrder')">
                                <v-icon small class="mr-2">
                                    mdi-delete
                                </v-icon>
                                Eliminar
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </template>
            </v-data-table>
        </v-col>
        <v-col cols="12" sm="6" md="2" v-if="shopping.received!=true">
            <v-btn @click="addDialog=true" color="primary" rounded class="elevation-0">Agregar</v-btn>
        </v-col>
        <!-- Crear envio -->
        <v-dialog v-model="addDialog" max-width="1000px">
            <add @closeDialogAddShopping="closeDialogAddShopping" v-bind:compra="shopping"/>
        </v-dialog>
        <!-- Editar envio -->
        <v-dialog v-model="editDialog" max-width="1000px">
            <edit v-bind:shoppingOrder="shoppingOrder" @closeDialogEditShopping="closeDialogEditShopping"/>
        </v-dialog>
        <!-- Dialogo confirmación de eliminación -->
        <div class="text-center">
            <v-bottom-sheet  v-model="sheet" inset>
                <v-sheet class="text-center" height="150px">
                    <div class="pt-6">
                        ¿Seguro que deseas borrar este producto de la compra?
                    </div>
                    <v-btn class="mt-4" text color="error" @click="deleteShopping()">
                        Eliminar
                    </v-btn>
                    <v-btn class="mt-4" text color="grey" @click="cancel()">
                        Cancelar
                    </v-btn>
                </v-sheet>
            </v-bottom-sheet>
        </div>
        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
    </v-row>
</template>

<script>
    import axios from "axios";
    import Add from "../detail/add"
    import Edit from "../detail/edit"
    export default {
        props:{
            shopping:Object
        },
        components: {
            'add':Add,
            'edit':Edit,
        },
        created(){
            const details = this.shopping.details
            this.shoppingDetail = details.map(id=>{
                return{
                    id: id.id,
                    unit: id.item?.unit?.name,
                    item_id: id.item?.name,
                    code_one: id.item?.code_one,
                    macro: id.item?.macro,
                    quantity: id.quantity,
                    unit_cost: (id.unit_cost*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}),
                    total: (id.unit_cost*id.quantity).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}),
                    created_by_user_id: id.created_by_user_id?.name + ' ' + (id.created_by_user_id?.last|''),
                    created_at: id.created_at ? id.created_at.slice(0, 10) : '',
                    last_updated_by_user_id: id.last_updated_by_user_id?.name + ' ' + (id.last_updated_by_user_id?.last|''),
                    updated_at: id.updated_at ? id.updated_at.slice(0, 10) : '',
                    editedItem: {
                        id: id.id,
                        item_id: id.item?.id,
                        item:id.item,
                        quantity: id.quantity,
                        unit_cost: id.unit_cost,
                        original_cost: id.unit_cost / (1 - id.discount/100),
                        shopping_id: id.shopping_id,
                        merma: 0,
                        created_by_user_id: id.created_by_user ? id.created_by_user.id : null,
                        discount:id.discount
                    }
                }
            });
        },
        data: () => ({
            shoppingDetail:[],
            addDialog:false,
            editDialog:false,
            sheet:false,
            deleteId:'',
            shoppingOrder:'',
            snackbar: {
                show: false,
                message: null,
                color: null
            },
            originalShopping:''
        }),
        computed: {
            currentUser(){
                return this.$store.state.currentUser.user;
            },
            headers(){ 
                var h = [
                    { text: 'Unidad', value: 'unit' },
                    //{ text: 'Codigo Macro', value: 'macro',},
                    { text: 'Código 1', value: 'code_one' },
                    { text: 'Producto', value: 'item_id' },
                    { text: 'Cantidad', value: 'quantity' },
                ]
                // Solo agrega costos si tiene permiso
                if(this.permissions('view_costs')){
                    h.push({ text: 'Costo Unitario', value: 'unit_cost' });
                    h.push({ text: 'Costo total', value: 'total' });
                }
                // Columnas adicionales
                h = h.concat([
                    /*{ text: 'Crea', value: 'created_by_user_id' },
                    { text: 'Creación', value: 'created_at' },
                    { text: 'Edita', value: 'last_updated_by_user_id' },
                    { text: 'Edición', value: 'updated_at' },*/
                    { value: 'actions', sortable: false, align: 'end' },
                ]);
                return h
            },
        },
        methods:{
            permissions(permission){
                if(this.currentUser.id == 1){
                    return true
                } else if(this.currentUser.permissions != undefined){
                    return this.currentUser.permissions.includes(permission)
                } else{
                    return false
                }
            },
            // Asume que created_by_user y last_updated_by_user son objetos con nombre/last (ajusta si solo es id)
            userName(userObj){
                if(!userObj) return ''
                if (typeof userObj === 'object') {
                    // Busca name y last, si no hay, fallback a username o solo name
                    return (userObj.name ? userObj.name : '') + 
                        (userObj.last ? ' ' + userObj.last : (userObj.lastname ? ' ' + userObj.lastname : ''))
                }
                // Si solo trae el id, busca en el store
                const user = this.$store.state.user.users.find(user=>user.id==userObj)
                if (user) return user.name + ' ' + user.last
                return ''
            },
            deleteItem (item) {
                this.deleteId = item.id
                this.sheet = true
            },
            deleteShopping(){
                axios.delete(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/shopping_details/"+this.deleteId).then(response => {
                    this.deleteId = ''
                    this.sheet = false
                    this.$store.dispatch('shopping_detail/getShoppingDetails')
                    this.$emit('refresh-shopping')
                }).catch(error => {
                    this.snackbar = {
                        message: error.response.data.message,
                        color: 'error',
                        show: true
                    }
                });
            },
            cancel(){
                this.deleteId = ''
                this.sheet = false
            },
            editItem(editedItem){
                this.shoppingOrder = editedItem
                this.editDialog = true
            },
            closeDialogEditShopping() {
                this.editDialog = false;
                this.$store.dispatch('shopping_detail/getShoppingDetails')
                this.$emit('refresh-shopping')
            },
            closeDialogAddShopping() {
                this.addDialog = false;
                this.$store.dispatch('shopping_detail/getShoppingDetails')
                this.$emit('refresh-shopping')
            },
        }
    }
</script>
